/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_content_delivery_bucket": "atlas-20190814103201-hostingbucket-stagingc",
    "aws_content_delivery_bucket_region": "us-east-1",
    "aws_content_delivery_url": "https://d1y76dxvwrkpst.cloudfront.net",
    "aws_cognito_identity_pool_id": "us-east-1:a7d8b36a-b343-4bad-938e-a833b0f69483",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_KpuKAIeKC",
    "aws_user_pools_web_client_id": "fo2tgjec8aapoo11oc294j1dl",
    "oauth": {},
    "aws_appsync_graphqlEndpoint": "https://7qqwcyw3dbfpxib5yevoif7ope.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cloud_logic_custom": [
        {
            "name": "AdminQueries",
            "endpoint": "https://mtqxi5xxi6.execute-api.us-east-1.amazonaws.com/stagingc",
            "region": "us-east-1"
        }
    ],
    "aws_user_files_s3_bucket": "amplify-storage-bucketstagingc-stagingc",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
